var _path, _path2, _path3, _circle, _circle2, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgIn = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 512 512"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#f0f0f0",
  d: "M0 85.337h512v341.326H0z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#ff9811",
  d: "M0 85.337h512v113.775H0z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#6da544",
  d: "M0 312.888h512v113.775H0z"
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 256,
  cy: 256,
  r: 43.896,
  fill: "#0052b4"
})), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
  cx: 256,
  cy: 256,
  r: 27.434,
  fill: "#f0f0f0"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#0052b4",
  d: "M256 222.146l8.464 19.195 20.855-2.268L272.927 256l12.392 16.927-20.855-2.268L256 289.854l-8.464-19.195-20.855 2.268L239.073 256l-12.392-16.927 20.855 2.268z"
})));

export default SvgIn;